import api from './api';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  body: string;
  link?: string;
  createdAt: string;
  readAt?: string;
}

class NotificationService {
  /**
   * Get all notifications for the current user
   */
  async getNotifications(unreadOnly: boolean = false): Promise<Notification[]> {
    const response = await api.get<ApiResponse<Notification[]>>(
      `/notifications${unreadOnly ? '?unreadOnly=true' : ''}`
    );
    return response.data.data;
  }

  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<number> {
    const response = await api.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
    return response.data.data.count;
  }

  /**
   * Mark a notification as read
   */
  async markAsRead(notificationId: string): Promise<Notification> {
    const response = await api.post<ApiResponse<Notification>>(
      `/notifications/${notificationId}/read`
    );
    return response.data.data;
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await api.post<ApiResponse<{ message: string }>>('/notifications/mark-all-read');
  }
}

export const notificationService = new NotificationService();
export default notificationService;

